import React, {useEffect} from 'react';
import {useFormik} from 'formik';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "../../common/hook";
import {useInputWithFocus} from "../../common/hook/useInputWithFocus";
import {setChangePasswordAC} from "../../app/popups-reducer";
import {fetchChangePassword} from "../../features/model/service/feactch-change-password/fetchChangePassword";
import {message} from 'antd';
import {setChangePasswordError} from "../../features/model/slice/сhange-assword/changePassword";

export interface ChangePasswordFormValues {
    oldPassword: string;
    password: string;
    retypePassword: string;
}

export const FormChangePassword = () => {
    const dispatch = useAppDispatch();
    const {errors,error,success} = useAppSelector(state => state.changePasswordError)


    const {isFilled, handleFocus, handleBlur} = useInputWithFocus(
        [false, false, false, false, false, false, false, false, false, false]
    );

    const successMessage = () => {
        message.success('Пароль успешно изменен');
    };

    const onClickHandler = () => {
        dispatch(setChangePasswordAC(false));
    };

    useEffect(() => {
        if (success) {
            onClickHandler();
            successMessage();
            dispatch(setChangePasswordError({success: false, error: '', errors: {}}))
        }
    }, [dispatch, success]);


    const handleSubmit = async (values: ChangePasswordFormValues) => {
        try {
            const changePasswordAction = fetchChangePassword({
                oldPassword: values.oldPassword,
                password: values.password,
                retypePassword: values.retypePassword,
            });
            await dispatch(changePasswordAction);
        } catch (error) {
        }
    };


    const formik = useFormik<ChangePasswordFormValues>({
        initialValues: {
            oldPassword: '',
            password: '',
            retypePassword: '',
        },
        onSubmit: handleSubmit,
    });

    return (
        <>
            <p className="h3 popup-title">Сменить пароль</p>
            <form
                className="form"
                onSubmit={formik.handleSubmit}
            >
                <div className="fields-row">
                    <div
                        className={`field has-icon-inp ${isFilled[0] ? 'filled' : ''} ${errors?.oldPassword ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.oldPassword ? 'active-label' : ''}`}>
                            Старый пароль
                        </label>
                        <div className="inp-box">
                            <input
                                type="password"
                                name="oldPassword"
                                className="form-control"
                                value={formik.values.oldPassword}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors?.oldPassword && <p className="field-error">{errors?.oldPassword}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[1] ? 'filled' : ''} ${errors?.password ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.password ? 'active-label' : ''}`}>
                            Новый пароль
                        </label>
                        <div className="inp-box">
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(1)}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors?.password && <p className="field-error">{errors?.password}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[2] ? 'filled' : ''} ${errors?.retypePassword ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.retypePassword ? 'active-label' : ''}`}>
                            Подтвердить новый пароль
                        </label>
                        <div className="inp-box">
                            <input
                                type="password"
                                name="retypePassword"
                                className="form-control"
                                value={formik.values.retypePassword}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(2)}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors?.retypePassword && <p className="field-error">{errors?.retypePassword}</p>}
                    </div>
                </div>
                <button type="submit" className="btn full-width">
                    <span>Сменить</span>
                </button>
            </form>
            <span className="js-close-popup" onClick={onClickHandler}>
                 <CloseIcon/>
            </span>
        </>
    );
};

